import { FC } from 'react'
import cn from 'classnames'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { ModalSimple } from 'components/ModalSimple'
import { getCorrectDuration } from 'helpers/dates'
import { TCheckOutSchedule } from 'modules/order/types'
import { TDayOfWeek } from 'modules/terminal/types'

import { ModalScheduleProps } from './types'

import s from './ModalSchedule.module.less'

export const ModalSchedule: FC<ModalScheduleProps> = (props) => {
  const { id, schedule, isLoading, handleCloseModalSchedule } = props

  const days: TDayOfWeek[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

  const dayOfWeekDictionary: Record<TDayOfWeek, string> = {
    mon: 'пн',
    tue: 'вт',
    wed: 'ср',
    thu: 'чт',
    fri: 'пт',
    sat: 'сб',
    sun: 'вс'
  }

  const getCorrectSchedule = () => {
    const scheduleNew: TCheckOutSchedule[] = []

    for (let i = 0; i < days.length; i++) {
      const scheduleItem = schedule?.find((item: TCheckOutSchedule) => item.day === days[i])

      if (scheduleItem) {
        scheduleNew.push(scheduleItem)
      } else {
        // TODO проблема в enum
        // @ts-ignore
        scheduleNew.push({ day: days[i] })
      }
    }

    return scheduleNew
  }

  const getCorrectTime = (time?: string): string => {
    if (!time) {
      return ''
    }

    return time ? time.slice(0, 5) : '' // от hh:mm:ss оставляем только hh:mm
  }

  return (
    <ModalSimple id={id} onClose={handleCloseModalSchedule} size="nm" title="График отправлений">
      <div className={s.detailBody}>
        {schedule?.length ? <div className={cn(s.scheduleText, s.nopt)}>Срок доставки/время выезда</div> : ''}
        {/* eslint-disable-next-line */}
        {!isLoading ? (
          schedule?.length ? (
            <div className={s.schedule}>
              {getCorrectSchedule().map((el: TCheckOutSchedule, index: number) => (
                <div key={index} className={s.scheduleDay}>
                  <div className={s.day}>{dayOfWeekDictionary[el.day]}</div>
                  <div className={s.duration}>{getCorrectDuration(el.duration)}</div>
                  <div className={s.time}>{getCorrectTime(el.time)}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-body-lg text-negative">
              На данный момент для выбранного направления нет информации о сроках доставки и времени выезда машин.
            </div>
          )
        ) : (
          <PlaceholderCell height={76} />
        )}
      </div>
    </ModalSimple>
  )
}
